import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'LIBRARY/Components/ResourceDetails/resourceDetails.css';
import LibraryApiCall from 'LibraryApiCall';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import Select from 'react-select';
import { Base64 } from 'js-base64';
import { toast } from 'react-toastify';

let multipleSelectOption = [];
let locationSubLocationData = [];
let categorySubCategoryData = [];

class EditResourceDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resourceResponseData: {},
            loadingResourceData: false,
            resourceData: {},

            selectedRows: [],

            //STATE FOR ACTION
            itemVisibilityForRows: [
                { name: "Accession Series", key: 'updateAccessionSeries' },
                { name: 'Accession Number', key: 'updateAccessionNumber' },
                { name: 'Accession Date', key: 'updateAccessionDate' },
                { name: "Call Number", key: 'updateCallNumber' },
                { name: "Title", key: 'updateTitle' },
                { name: "Author Name", key: 'updateAuthorName' },
                { name: "Resource Volume", key: 'updateResourceVolume' },
                { name: "Resource Edition", key: 'updateResourceEdition' },
                { name: "Resource Language", key: 'updateResourceLanguage' },
                { name: "Publisher", key: 'updatePublisher' },
                { name: "Number of Pages", key: 'updateNoOfPages' },
                { name: "Number of Preliminary Pages", key: 'updateNoOfPreliminaryPages' },
                { name: "Resource Category", key: 'updateResourceCategory' },
                { name: "Year of Publication", key: 'updateYearOfPublication' },
                { name: "Department", key: 'updateDepartment' },
                { name: "Resource Type", key: 'updateResourceType' },
                { name: "Translator Name", key: 'updateTranslatorName' },
                { name: "Translated", key: 'updateTranslated' },
                { name: "Search Keyword", key: 'updateSearchKeyword' },
                { name: "Location", key: 'updateLocation' },
                { name: "ISBN Number", key: 'updateIsbnNumber' },
                { name: "Resource Condition", key: 'updateResourceCondition' },
                { name: "Donated", key: 'updateDonated' },
                { name: "Resource Attachment", key: 'updateResourceAttachment' },
                { name: "Specimen", key: 'updateSpecimen' },
                { name: "Invoice/Bill No.", key: 'updateInvoiceNo' },
                { name: "Price", key: 'updatePrice' },
                { name: "Discount", key: 'updateDiscount' },
                { name: "Resource Status", key: 'updateResourceStatus' },
            ],

            actionButtonTitle: '',
            selectedValue: [],
            isMultiSelect: false,
            selectedCheckbox: false,
            Translated: 'Yes',
            ResourceAttachment: [],
            fieldNamePayload: '',
            fieldValuePayload: '',
            invoiceDate: '',
            updateResourceLoading: false
        }
    }

    componentDidMount() {
        this.GetLibraryResourceDetails()
    }

    // basic resource list
    GetLibraryResourceDetails = async () => {
        this.setState({
            loadingResourceData: true
        });

        let requestData = {
            iid: this.props.ResourceData.resourceIID, // config.institute_id,
            uniqueid: this.props.ResourceData.uniqueId
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "GetLibraryResourceDetails",
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                let filteredResponseData = Object.entries(apiResult)
                    .filter(([key, value]) => key == this.props.ResourceData.uniqueId)
                    .map(([key, value]) => ({ id: key, ...value }));

                this.setState({
                    resourceResponseData: apiResult,
                    resourceData: filteredResponseData,
                    loadingResourceData: false
                });
            }
        }
    };


    closeViewResourceModal = () => {
        this.props.onClose(); // Call parent function directly
    }

    // single checkbox check 
    handleCheckboxChange = (id) => {
        this.setState((prevState) => {
            const selectedRows = prevState.selectedRows.includes(id)
                ? prevState.selectedRows.filter((rowId) => rowId !== id) // Remove if already selected
                : [...prevState.selectedRows, id]; // Add if not selected

            return { selectedRows };
        });

    };

    // multiple checkbox check 
    handleSelectAllCheckboxChange = () => {
        this.setState((prevState) => {
            const allRowsSelected = prevState.selectedRows.length === Object.values(this.state.resourceResponseData).length;

            return {
                selectedRows: allRowsSelected ? [] : Object.values(this.state.resourceResponseData).map((project) => project.uniqueId),
            };
        });
    };

    // METHOD TO EMPTY DATA ON FILE CLICK
    onFileClick = (e) => {
        e.target.value = "";
    }

    // METHOD TO CLICK ON INPUT TYPE FILE
    getAttachmentClick = () => {
        document.getElementById('edit-attachment-files').click();
    }

    // METHOD TO GET ATTACHMENT FILES
    getAttachments = (e) => {

        let attachments = this.state.ResourceAttachment;
        let validData = true;
        let fileData = [e.target.files[0]];
        Object.values(fileData).map(file => {
            let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
            let fileSize = file.size / 1048576;
            if (fileExtension != 'jpeg' || fileExtension != 'jpg' || fileExtension != 'png' || fileExtension != 'svg' || fileExtension != 'bmp') {
                this.setState({
                    fileSelectionWarning: 'Please select files with .jpeg, .jpg, .png, .svg, .bmp only.'
                });
                validData = false;
            } else {
                this.setState({
                    fileSelectionWarning: ''
                });
                validData = true;
            }

            if (fileSize > 5) {
                this.setState({
                    fileSelectionWarning: 'Please select file less than 5MB.'
                });
                validData = false;
            } else {
                this.setState({
                    fileSelectionWarning: ''
                });
                validData = true;
            }

            if (validData) {
                attachments.push(file);
                this.setState({
                    attachments,
                    ResourceAttachment: fileData,
                    fileSelectionWarning: ''
                });
            }
        });
    }

    // action button on change
    actionHandleChange = (key) => {
        if (key == 'Accession Series' || key == 'Resource Language' || key == 'Resource Type' || key == 'Location' || key == 'Resource Condition' || key == 'Invoice/Bill No.' || key == 'Resource Status' || key == 'Donated' || key == 'Translated') {
            this.setState({
                isMultiSelect: false, selectedValue: [], selectedCheckbox: false, Translated: '', ResourceAttachment: [], fieldNamePayload: '', fieldValuePayload: '', invoiceDate: ''
            });
        } else {
            this.setState({
                isMultiSelect: true, selectedValue: [], selectedCheckbox: false, Translated: '', ResourceAttachment: [], fieldNamePayload: '', fieldValuePayload: '', invoiceDate: ''
            });
        }
    }

    // apply button onChange - set dynamically input parameter based on action button
    UpdateResourceData = () => {
        if (this.state.actionButtonTitle == "Accession Series") {
            this.setState({ fieldNamePayload: 'accession_series_id', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Accession Number") {
            this.setState({ fieldNamePayload: 'accessionnumber', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Accession Date") {
            this.setState({ fieldNamePayload: 'accession_date', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Call Number") {
            this.setState({ fieldNamePayload: 'callNumber', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Title") {
            this.setState({ fieldNamePayload: 'title', fieldValuePayload: Base64.encode(this.state.selectedValue) }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Author Name") {
            this.setState({ fieldNamePayload: 'author', fieldValuePayload: Base64.encode(this.state.selectedValue) }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Resource Volume") {
            this.setState({ fieldNamePayload: 'volume', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Resource Edition") {
            this.setState({ fieldNamePayload: 'edition', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Resource Language") {
            this.setState({ fieldNamePayload: 'resource_lang', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Publisher") {
            let formattedValue = this.state.selectedValue?.length > 0 ? this.state.selectedValue.map(item => item.value) : [this.state.selectedValue.value];
            let jsonFormattedData = JSON.stringify(formattedValue);
            this.setState({ fieldNamePayload: 'publisher', fieldValuePayload: jsonFormattedData }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Number of Pages") {
            this.setState({ fieldNamePayload: 'number_of_pages', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Number of Preliminary Pages") {
            this.setState({ fieldNamePayload: 'preliminary_pages', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Resource Category") {
            let formattedValue = this.state.selectedValue?.length > 0 ? this.state.selectedValue.map(item => item.value) : [this.state.selectedValue.value];
            let jsonFormattedData = JSON.stringify(formattedValue);
            this.setState({ fieldNamePayload: 'resourceCategory', fieldValuePayload: jsonFormattedData }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Year of Publication") {
            this.setState({ fieldNamePayload: 'yearOfPublication', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Department") {
            let formattedValue = this.state.selectedValue?.length > 0 ? this.state.selectedValue.map(item => item.value) : [this.state.selectedValue.value];
            let jsonFormattedData = JSON.stringify(formattedValue);
            this.setState({ fieldNamePayload: 'stream_id', fieldValuePayload: jsonFormattedData }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Resource Type") {
            this.setState({ fieldNamePayload: 'resource_type', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Translator Name") {
            this.setState({ fieldNamePayload: 'translator', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Translated") {
            this.setState({
                fieldNamePayload: 'transalated', fieldValuePayload: this.state.selectedValue.value
                // this.state.Translated 
            }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Search Keyword") {
            this.setState({ fieldNamePayload: 'search_key_word', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Location") {
            this.setState({ fieldNamePayload: 'location', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "ISBN Number") {
            this.setState({ fieldNamePayload: 'isbn_number', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Resource Condition") {
            this.setState({ fieldNamePayload: 'resource_condition', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Donated") {
            this.setState({ fieldNamePayload: 'donated', fieldValuePayload: this.state.selectedValue.value || "on" }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Resource Attachment") {  // path send in value
            let file_name = this.state.ResourceAttachment[0]?.name;
            let file_path_value = "C:\\fakepath\\" + file_name

            this.setState({ fieldNamePayload: 'resource_attachment', fieldValuePayload: file_path_value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Specimen") {
            this.setState({ fieldNamePayload: 'specimen', fieldValuePayload: this.state.selectedCheckbox }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Invoice/Bill No.") {
            this.setState({ fieldNamePayload: 'invoiceno', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Price") {
            this.setState({ fieldNamePayload: 'price', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Discount") {
            this.setState({ fieldNamePayload: 'discount', fieldValuePayload: this.state.selectedValue }, () => {
                this.apiCallForUpdateResourceData()
            })
        } else if (this.state.actionButtonTitle == "Resource Status") {
            this.setState({ fieldNamePayload: 'resource_status', fieldValuePayload: this.state.selectedValue.value }, () => {
                this.apiCallForUpdateResourceData()
            })
        }
    }

    apiCallForUpdateResourceData = async () => {
        this.setState({
            updateResourceLoading: true
        });

        let requestData = {}
        let jsonResponse = {}
        let requestDonatedData = {}

        let resourceObject = {
            "fieldsObj": { "fieldName": this.state.fieldNamePayload, "value": this.state.fieldValuePayload }, "selectedCopiesIdArray": this.state.selectedRows
        }

        let resourceDonatedObject = {
            "fieldsObj": { "fieldName": this.state.fieldNamePayload, "value": this.state.fieldValuePayload }, "selectedIdArray": this.state.selectedRows
        }

        requestData = {
            iid: this.props.ResourceData.resourceIID, // config.institute_id,
            resourceObject: resourceObject,
            facultyId: config.faculty_id,
            uniqueId: this.props.ResourceData.uniqueId
        }

        requestDonatedData = {
            iid: this.props.ResourceData.resourceIID, // config.institute_id,
            resourceObject: resourceDonatedObject,
            facultyId: config.faculty_id,
        }

        {
            this.state.actionButtonTitle == "Donated" && this.state.selectedValue.value ?
                jsonResponse = await LibraryApiCall.makeApiCall(
                    "updateLibraryResourceSelectedFiledofSelectedResource",
                    requestDonatedData,
                    "/api/library/instructor.php"
                )
                :
                jsonResponse = await LibraryApiCall.makeApiCall(
                    "UpdateLibraryResource",
                    requestData,
                    "/api/library/instructor.php",
                    this.state.ResourceAttachment
                )
        }

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallForUpdateResourceData()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult.status == "success") {
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.setState({
                        updateResourceLoading: false
                    });
                    this.closeViewResourceModal()
                } else {
                    this.setState({
                        updateResourceLoading: false
                    });
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                this.setState({
                    updateResourceLoading: false
                });
                toast.error('Something went wrong while updating resources data. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    render() {
        const { editResourceData } = this.props;

        // dynamically set Option value for Select dropdown based on action button 
        if (this.state.actionButtonTitle == "Accession Series") {
            multipleSelectOption = this.props.accessionSeriesListData
        } else if (this.state.actionButtonTitle == "Resource Language") {
            multipleSelectOption = this.props.resourceLanguageData.map(item => ({
                value: item,
                label: item
            }));
        } else if (this.state.actionButtonTitle == "Publisher") {
            multipleSelectOption = this.props.publisherData.map(item => ({
                value: item.value,
                label: item.name
            }));
        } else if (this.state.actionButtonTitle == "Resource Category") {
            // custom category and sub-category data list
            categorySubCategoryData = Object.values(this.props.resourceCategoryData).flatMap(item => {
                // Start with the category itself
                const categoryOption = {
                    value: item.value,
                    label: item.name,
                    isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
                };

                // If the category has subcategories, add those as well
                const subCategoryOptions = item.subCategories.map(subCategory => ({
                    value: subCategory.subCategoryId,
                    label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                    isDisabled: false, // Subcategory is always enabled
                }));

                // Return the category option followed by the subcategory options
                return [categoryOption, ...subCategoryOptions];
            });

            multipleSelectOption = categorySubCategoryData;
        } else if (this.state.actionButtonTitle == "Department") {
            multipleSelectOption = this.props.streamListData.map(item => ({
                value: item.sid,
                label: item.name
            }));
        } else if (this.state.actionButtonTitle == "Resource Type") {
            multipleSelectOption = this.props.resourceTypeData.map(item => ({
                value: item,
                label: item
            }));
        } else if (this.state.actionButtonTitle == "Location") {
            // custom location and sub-location data list
            locationSubLocationData = Object.values(this.props.locationListData).reduce((acc, location) => {
                const { value, name, sublocations } = location;

                if (sublocations && sublocations.length > 0) {
                    // Parent location (disabled)
                    acc.push({
                        value: value,
                        label: name.length > 25 ? name.slice(0, 25) + '...' : name,
                        isDisabled: true,
                    });

                    // Add each sublocation as selectable
                    const subOptions = sublocations.map(sub => {
                        const label = `${name} => ${sub.sublocationName}`;
                        return {
                            value: sub.sublocationId,
                            label: label.length > 25 ? label.slice(0, 25) + '...' : label,
                        };
                    });

                    acc.push(...subOptions);
                } else {
                    // Location with no sublocations (selectable)
                    acc.push({
                        value: value,
                        label: name.length > 25 ? name.slice(0, 25) + '...' : name,
                        isDisabled: false,
                    });
                }

                return acc;
            }, []);

            multipleSelectOption = locationSubLocationData;
        } else if (this.state.actionButtonTitle == "Resource Condition") {
            multipleSelectOption = this.props.resourceConditionData.map(item => ({
                value: item,
                label: item
            }));
        } else if (this.state.actionButtonTitle == "Invoice/Bill No.") {
            multipleSelectOption = this.props.invoiceData.map(item => ({
                value: item.value,
                label: item.billno + " | " + item.billdate + " | " + item.vendorName
            }));
        } else if (this.state.actionButtonTitle === "Resource Status") {
            multipleSelectOption = Object.values(this.props.resourceStatusData).map(item => ({
                value: item.status,
                label: item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : ''  // item.status
            }));
        } else if (this.state.actionButtonTitle === "Donated") {
            multipleSelectOption = this.props.donorsListData
        } else if (this.state.actionButtonTitle === "Translated") {
            multipleSelectOption = [
                { value: "Yes", label: "Yes" },
                { value: "No", label: "No" }
            ];
        }

        return (
            <div id="addAccessSideMenu" style={{ display: editResourceData ? 'flex' : 'none' }}>
                <div id="addResourceDataContainer">
                    {/* header */}
                    <div id="addAccessHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeViewResourceModal()} style={{ cursor: "pointer" }} />
                        <h5 style={{ paddingLeft: '40%' }} className="col-11">Edit Resource</h5>
                    </div>

                    {/* content */}
                    <div className="col-md-12 p-4">
                        <div className="d-flex align-items-center mb-2" style={{ gap: '10px', flexWrap: 'wrap' }}>
                            {/* Action Button */}
                            <div style={{ position: 'relative' }}>
                                <button className="btn btn-primary" id='actionDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" disabled={this.state.selectedRows.length === 0}>
                                    Action <FontAwesomeIcon size='lg' icon={["fa", "sort-down"]} style={{ cursor: "pointer" }} />
                                </button>
                                <div className="dropdown-menu  vm-dropdown-menu" aria-labelledby='actionDropdownMenu' style={{
                                    maxHeight: '250px',  // Set your desired height
                                    overflowY: 'auto',
                                    boxShadow: '4px 4px 10px #b7adad'
                                }}>
                                    {
                                        this.state.itemVisibilityForRows.map((columnInfo, index) => {
                                            return (
                                                <p className="dropdown-item"
                                                    style={{
                                                        display: 'flex', justifyContent: 'space-between', fontSize: '13px', cursor: 'pointer', padding: '6px 8px',
                                                        marginBottom: '3px'
                                                    }}
                                                    key={columnInfo.name}
                                                    onClick={() => this.setState({ actionButtonTitle: columnInfo.name, dateWarning: '' }, () => {
                                                        this.actionHandleChange(columnInfo.name)
                                                    })}
                                                >
                                                    <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                </p>
                                            );
                                        })
                                    }
                                </div>
                            </div>

                            {/* Conditionally Rendered fields */}
                            {this.state.selectedRows.length !== 0 ?
                                <>
                                    {this.state.actionButtonTitle == 'Accession Series' || this.state.actionButtonTitle == 'Resource Language' || this.state.actionButtonTitle == 'Resource Type' || this.state.actionButtonTitle == 'Location' || this.state.actionButtonTitle == 'Resource Condition' || this.state.actionButtonTitle == 'Invoice/Bill No.' || this.state.actionButtonTitle == 'Resource Status' || this.state.actionButtonTitle == 'Publisher' || this.state.actionButtonTitle == 'Resource Category' || this.state.actionButtonTitle == 'Department' || this.state.actionButtonTitle == 'Translated' ?
                                        <>
                                            <Select
                                                isMulti={this.state.isMultiSelect}
                                                options={multipleSelectOption}
                                                onChange={(event) => {
                                                    this.setState({
                                                        selectedValue: event || []
                                                    }, () => {
                                                        if (this.state.actionButtonTitle == 'Invoice/Bill No.') {
                                                            // Assuming invoiceData is an array of objects where each object has "billno" and "billDate"
                                                            const selectedInvoice = this.props.invoiceData?.find(item => item.value == this.state.selectedValue.value);
                                                            this.setState({ invoiceDate: selectedInvoice.billdate || '' });
                                                        }
                                                    })
                                                }}
                                                isSearchable
                                                isClearable
                                                value={this.state.selectedValue}
                                                placeholder={`Select ${this.state.actionButtonTitle}`}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: 42, // Minimum height for the control area
                                                        height: 'auto', // Allow control to grow dynamically,
                                                        fontSize: "13px",
                                                        fontWeight: 400,
                                                        width: '100%'
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        fontSize: "13px",
                                                        fontWeight: 400,
                                                        // backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                        // color: state.isSelected ? '#333' : '#555',
                                                        backgroundColor: state.isDisabled ? '#f0f0f0' : state.isFocused ? '#e0e0e0' : 'white',
                                                        color: state.isDisabled ? '#999' : '#555',
                                                        cursor: state.isDisabled ? 'not-allowed' : 'default',
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999, // Ensure the dropdown appears above other elements
                                                        // maxHeight: '200px', // Limit the height of the dropdown
                                                        overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                        position: 'absolute', // Fix the position to avoid getting cut off
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999, // Ensure the menu is above other modal content
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        fontSize: '14px',
                                                        fontWeight: '400', // Use fontWeight for normal text

                                                    }),
                                                }}
                                                menuPortalTarget={document.body}
                                            />
                                            {this.state.actionButtonTitle == 'Invoice/Bill No.' &&
                                                < input
                                                    type='text'
                                                    placeholder={`Invoice Bill Date`}
                                                    value={this.state.invoiceDate}
                                                    style={{ width: '200px' }} // Correct way to apply inline style as an object
                                                    className="form-control filterInput"
                                                    onChange={(e) => {
                                                    }}
                                                    disabled={true}
                                                />}
                                        </>
                                        : this.state.actionButtonTitle == 'Accession Number' || this.state.actionButtonTitle == 'Call Number' || this.state.actionButtonTitle == 'Title' || this.state.actionButtonTitle == 'Author Name' || this.state.actionButtonTitle == 'Resource Volume' || this.state.actionButtonTitle == 'Resource Edition' || this.state.actionButtonTitle == 'Number of Pages' || this.state.actionButtonTitle == 'Number of Preliminary Pages' || this.state.actionButtonTitle == 'Year of Publication' || this.state.actionButtonTitle == 'Translator Name' || this.state.actionButtonTitle == 'Search Keyword' || this.state.actionButtonTitle == 'ISBN Number' || this.state.actionButtonTitle == 'Price' || this.state.actionButtonTitle == 'Discount' ?
                                            <input
                                                type='text'
                                                placeholder={`Enter ${this.state.actionButtonTitle}`}
                                                value={this.state.selectedValue}
                                                style={{ width: '200px' }} // Correct way to apply inline style as an object
                                                className="form-control filterInput"
                                                // onChange={(e) => {
                                                //     this.setState({ selectedValue: e.target.value })
                                                // }}
                                                onChange={(e) => {
                                                    let value = e.target.value;

                                                    // ✅ If field is Price or Discount → allow decimals up to 2 places
                                                    if (this.state.actionButtonTitle === 'Price' || this.state.actionButtonTitle === 'Discount') {
                                                        if (value === '' || /^\d+(\.\d{0,2})?$/.test(value)) {
                                                            this.setState({ selectedValue: value });
                                                        }
                                                    } 
                                                    else if (this.state.actionButtonTitle === 'Year of Publication') {
                                                        if (value === '' || /^\d{0,4}(-(\d{0,2}|\d{0,4}))?$/.test(value)) {
                                                            this.setState({ selectedValue: value });
                                                        }
                                                    }
                                                    else {
                                                        this.setState({ selectedValue: value });
                                                    }
                                                }}
                                                maxLength={this.state.actionButtonTitle === 'Accession Number' ? 20 : undefined}
                                            />
                                            : this.state.actionButtonTitle == 'Accession Date' ?
                                                <input
                                                    type='date'
                                                    placeholder={`Enter ${this.state.actionButtonTitle}`}
                                                    value={this.state.selectedValue}
                                                    style={{ width: '200px' }} // Correct way to apply inline style as an object
                                                    className="form-control filterInput"
                                                    onChange={(event) => {
                                                        const selectedDate = event.target.value;

                                                        if (selectedDate) {
                                                            const year = selectedDate.split("-")[0];
                                                            if (year.length === 4 && !isNaN(parseInt(year))) {
                                                                this.setState({
                                                                    selectedValue: selectedDate,
                                                                    dateWarning: '' // clear any previous error
                                                                });
                                                            } else {
                                                                this.setState({
                                                                    dateWarning: "Year must be a 4-digit number.",
                                                                    selectedValue: ''
                                                                });
                                                            }
                                                        } else {
                                                            this.setState({
                                                                selectedValue: '',
                                                                dateWarning: ''
                                                            });
                                                        }
                                                    }}
                                                />
                                                : this.state.actionButtonTitle == 'Donated' || this.state.actionButtonTitle == 'Specimen' ?
                                                    <>
                                                        <input
                                                            type='checkbox'
                                                            onChange={(event) => {
                                                                this.setState({
                                                                    selectedCheckbox: event.target.checked, // Set true or false based on checkbox state
                                                                });
                                                            }}
                                                            checked={this.state.selectedCheckbox}
                                                            style={{ marginRight: 5 }}
                                                        />
                                                        <label className='fs-14 fieldHeadColor mt-2'>{this.state.actionButtonTitle == 'Donated' ? " Mark as donated" : "Check here if it is specimen copy"}</label>

                                                        {this.state.actionButtonTitle == 'Donated' && this.state.selectedCheckbox === true &&
                                                            <>
                                                                <Select
                                                                    isMulti={this.state.isMultiSelect}
                                                                    options={multipleSelectOption}
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            selectedValue: event || []
                                                                        })
                                                                    }}
                                                                    isSearchable
                                                                    isClearable
                                                                    value={this.state.selectedValue}
                                                                    placeholder={`Select ${this.state.actionButtonTitle}`}
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            minHeight: 42, // Minimum height for the control area
                                                                            height: 'auto', // Allow control to grow dynamically,
                                                                            fontSize: "13px",
                                                                            fontWeight: 400,
                                                                            width: '100%'
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            fontSize: "13px",
                                                                            fontWeight: 400,
                                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? '#333' : '#555',
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                            // maxHeight: '200px', // Limit the height of the dropdown
                                                                            overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                                            position: 'absolute', // Fix the position to avoid getting cut off
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Ensure the menu is above other modal content
                                                                        }),
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            fontSize: '14px',
                                                                            fontWeight: '400', // Use fontWeight for normal text

                                                                        }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </>
                                                        }
                                                    </>
                                                    // : this.state.actionButtonTitle == 'Translated' ?
                                                    //     <>
                                                    //         <label className='fs-14 fieldHeadColor mt-2'>Translated</label>
                                                    //         <div className="input-group input-group-field">
                                                    //             <div style={{ marginRight: '15px' }}>
                                                    //                 <input
                                                    //                     type="radio"
                                                    //                     name="Translated"
                                                    //                     checked={this.state.Translated == 'Yes'}
                                                    //                     onChange={() => this.setState({ Translated: 'Yes' })}
                                                    //                     style={{ marginRight: 5 }}
                                                    //                 />
                                                    //                 <span style={{ fontSize: 13 }}>Yes</span>
                                                    //             </div>
                                                    //             <div>
                                                    //                 <input
                                                    //                     type="radio"
                                                    //                     name="Translated"
                                                    //                     checked={this.state.Translated == 'No'}
                                                    //                     onChange={() => this.setState({ Translated: 'No' })}
                                                    //                     style={{ marginRight: 5 }}
                                                    //                 />
                                                    //                 <span style={{ fontSize: 13 }}>No</span>
                                                    //             </div>
                                                    //         </div>
                                                    //     </>
                                                    : this.state.actionButtonTitle == 'Resource Attachment' ?
                                                        <>
                                                            <label className='fs-14 fieldHeadColor mt-2'>Attach Image of Resource</label>
                                                            {
                                                                this.state.ResourceAttachment.length > 0 &&
                                                                Object.values(this.state.ResourceAttachment).map((attachment, index) => {
                                                                    return (
                                                                        <p className="attachedFile-name">
                                                                            {attachment.name}
                                                                        </p>
                                                                    );
                                                                })
                                                            }
                                                            <input
                                                                type="file"
                                                                id="edit-attachment-files"
                                                                onClick={(e) => this.onFileClick(e)}
                                                                onChange={(e) => this.getAttachments(e)}
                                                                style={{ display: 'none' }}
                                                                accept=".jpeg, .jpg, .png"
                                                            />
                                                            <button type="button" role="button" className="btn filesButton" onClick={this.getAttachmentClick}>
                                                                <FontAwesomeIcon icon={['fas', 'paperclip']} size="lg" style={{ cursor: "pointer", marginRight: 10 }} />
                                                                Choose Files
                                                            </button>
                                                        </> : null
                                    }
                                    {this.state.dateWarning && (
                                        <p style={{ color: 'red', fontSize: 12 }}>{this.state.dateWarning}</p>
                                    )}
                                    {this.state.actionButtonTitle === 'Accession Number' && (
                                        <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>
                                            (Maximum 20 characters are allowed)
                                        </p>
                                    )}
                                    {this.state.actionButtonTitle !== '' ?
                                        <button button className="btn btn-primary" onClick={() => this.UpdateResourceData()} disabled={this.state.updateResourceLoading}>Apply</button>
                                        : null}
                                    {this.state.updateResourceLoading ? <ButtonLoader /> : null}
                                    {this.state.actionButtonTitle == 'Donated' && this.state.selectedCheckbox === true &&
                                        <p style={{ textAlign: "left", fontSize: 14, padding: "10px", color: "red" }}>Note: If a resource is marked as donated then it will not have invoice details.</p>}
                                </>
                                : null}
                        </div>

                        {this.state.selectedRows.length === 0 ? <div className="note_title"><b>Warning! </b>Kindly select at least one resource copies.</div> : null}

                        <div className="table-responsive fixTableHead table_pad mt-4" id='tableResponsive'>
                            <div className="print-area">
                                <table className="table table-bordered  vm_libraryReport_table" id="resourceList">
                                    <thead>
                                        {/* Column headers */}
                                        <tr>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>
                                                <input
                                                    type='checkbox'
                                                    onChange={this.handleSelectAllCheckboxChange}
                                                    checked={
                                                        this.state.selectedRows.length === Object.values(this.state.resourceResponseData).length &&
                                                        Object.values(this.state.resourceResponseData).length > 0
                                                    }
                                                    style={{ marginRight: 5 }}
                                                />
                                            </th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Sr. No.</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Accession Series</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Accession Number</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Accession Date</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Call Number</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Title</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Author</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Resource Volume</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Resource Edition</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Resource Language</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Publisher</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Number of Pages</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Number of Preliminary Pages</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Resource Category</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Year of Publication</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Department</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Resource Type</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Translator Name</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Translated</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Search Keyword</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Location</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>ISBN Number</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Resource Condition</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Invoice/Bill No.</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Invoice/Bill Date</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Price</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Discount (in %)</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Net Price (in ₹ Per Copy)</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Resource Status</th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            this.state.loadingResourceData ? <tr>
                                                <td colSpan="30">
                                                    <ButtonLoader />
                                                </td>
                                            </tr> :
                                                Object.keys(this.state.resourceResponseData).length > 0 ?
                                                    (Object.values(this.state.resourceResponseData).map((resource, index) => (
                                                        <tr key={index}>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF'}}>
                                                                <input type='checkbox'
                                                                    onChange={() => this.handleCheckboxChange(resource.uniqueId)}
                                                                    checked={this.state.selectedRows.includes(resource.uniqueId)}
                                                                />
                                                            </td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{index + 1}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.AccessionText}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.accessionnumber}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.accession_date}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.callNumber}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.title}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.author}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.volume}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.edition}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.resource_lang}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.publishername}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.number_of_pages}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.preliminary_pages}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.resource_category_name}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.yearOfPublication}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.stream_name}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.resource_type}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.translator}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.transalated}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.search_key_word}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.location_name}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.isbn_number}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.resource_condition}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.billno}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.bill_date}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.price}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.discount}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.netprice}</p>}</td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.resource_status ? resource.resource_status.charAt(0).toUpperCase() + resource.resource_status.slice(1) : ''}</p>}</td>

                                                        </tr>
                                                    ))) :
                                                    <tr>
                                                        <td colSpan="11">
                                                            No data found.
                                                        </td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

export default EditResourceDetails;